export type DonorReportCategory = 'missing' | 'restored' | 'changed' | 'errors' | 'overdue';
export const DONOR_REPORT_CATEGORIES: DonorReportCategory[] = [
  'missing',
  'restored',
  'changed',
  'errors',
  'overdue',
];
export type DonorDeliveryStatus =
  'pending' | 'sending' | 'retrying' | 'sent' | 'failed' | 'unknown' | 'cancelled';
export interface DonorDeliveryView {
  id: string;
  kind: 'daily' | 'test';
  status: DonorDeliveryStatus;
  createdAt: string;
  attemptedAt: string | null;
  sentAt: string | null;
  error: string | null;
  chatId: string;
  topicId: number | null;
}
export interface DonorReportSettingsView {
  revision: number;
  enabled: boolean;
  sendTime: string;
  timeZone: string;
  channelId: string | null;
  topicId: number | null;
  categories: DonorReportCategory[];
  encryptionReady: boolean;
  nextSendAt: string | null;
  lastDaily: DonorDeliveryView | null;
  lastTest: DonorDeliveryView | null;
}
export interface DonorReportSettingsInput {
  revision: number;
  enabled: boolean;
  sendTime: string;
  timeZone: string;
  channelId: string | null;
  topicId: number | null;
  categories: DonorReportCategory[];
  connection?: { id?: string; title: string; chatId: string; botToken?: string; enabled?: boolean };
}
